import { AgrLoginTypes, IETFLocales, SignupSigninPolicy } from '@next/core-lib/environment';

import { Environment } from './environment.model';

export { Environment } from './environment.model';

export const environment: Environment = {
  APPLICATION_NAME: 'Management',
  API_BASE_URL: 'http://localhost:4200',
  CLIENT_ID: '8c830f86-9b7a-4d6b-a6bb-140b5ffcbd9b',
  REDIRECT_URL: 'http://localhost:4200',
  LOGIN_TYPE: AgrLoginTypes.redirect,
  SIGNUP_SIGNIN_POLICY: SignupSigninPolicy.Employee,
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2cdev.b2clogin.com/tfp/agrifirmb2cdev.onmicrosoft.com/',
  APPLICATION_KEY: 'Management',
  AUTHORIZED_BY: {},
  APP_INSIGHTS_KEY: '',
  DEFAULT_LOCALE: IETFLocales.en,
  LOCALES: [IETFLocales.nl, IETFLocales.en, IETFLocales.pl],
  PRODUCTION: false,
  USE_NEW_NOTIFICATIONS: true,
  APIM_BASE_URL: 'http://localhost:4200/external',
  MSAL_LOGGING: false,
  NGRX_LOGGING: false,
  ERROR_PAGE_HOME_BUTTON: true,
  ERROR_PAGE_BACK_BUTTON: true,
  CUSTOMER_IN_LOCATION_SELECTOR: true,
  SHOW_CART_ICON: false,
  SHOW_DISABLED_LOCATION_BADGE: false,
  SUBSCRIBE_TO_CART_EVENTS: false,
  IS_MY_PROSPECTS_HIDDEN: true,
  ARE_ORDER_BLOCKED_LOCATIONS_HIDDEN: true,
  SHOP_URL: '',
  DELIVERY_TIME_WINDOW_DISABLED: false,
};
